

function createCA_Storage() {
  var _storage = JSON.parse('{"visits":[]}');

  const CA_Storage = {
    data () {
      return {
        storage : _storage,
      }
    },

    getVisits() {
      return _storage.visits;
    },

    setVisit(entity, id, name) {
      var elementFound = false;
      for (var i = 0; i < _storage.visits.length; i++) {
        if (_storage.visits[i].entity == entity && _storage.visits[i].id == id) {
          _storage.visits[i].count = _storage.visits[i].count + 1;
          elementFound = true;
          break;
        }
      }
      if (!elementFound) {
        const d = new Date();
        var today = d.getFullYear().toString() + d.getMonth().toString() + d.getDate().toString();
        const newVisit = '{"entity":"' + entity + '", "id":' + id + ', "name":"' + name + '", "count":1, "lastUpdate":' + today + '}';
        console.log("newVisit: " + newVisit);
        _storage.visits.push(JSON.parse(newVisit));
      }
      localStorage.setItem("CA_Visits", JSON.stringify(_storage));
    },

    install(app) {
      const CA_Storage = this;
      app.config.globalProperties.$CA_Storage = CA_Storage;
      var fromStorage = localStorage.getItem("CA_Visits");
      console.log("Visits: " + JSON.stringify(fromStorage));
      if (fromStorage != null)
        _storage = JSON.parse(fromStorage); 
    }
  }

  return CA_Storage;
}

const _createCA_Storage = createCA_Storage;
export { _createCA_Storage as createCA_Storage };
